import { Select } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import { LOAN_PURPOSE_OPTIONS } from '@modules/investor/config/loanPurpose';
const LoanPurpose = ({ value, onChange }) => {
    const { t } = useTranslation();
    const options = LOAN_PURPOSE_OPTIONS.map((option) => ({
        value: option.id,
        label: t(option.translationKey),
    }));
    const handleChange = (selected) => {
        onChange(Array.isArray(selected) ? selected : [selected]);
    };
    return (<Select label={t('financing.investing_page_table.choose_purpose')} isMulti isSearchable value={value} onChange={handleChange} options={options} placeholder={t('financing.investing_page_table.choose_purpose')}/>);
};
export default LoanPurpose;
